module.exports = __webpack_public_path__ + "417419b9bb5ab990118e6c27e1fe04df.svg";